import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from './paths';

/**
 * The "Back" of a dedicated view: the previous page of this app, or the console when the view
 * was opened directly (a shared link or a reload) and there is nothing earlier to return to.
 * React Router numbers the entries of a session in `history.state.idx`.
 */
export function useGoBack(): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate(ROUTES.console, { replace: true });
  }, [navigate]);
}
